import { render, staticRenderFns } from "./BankAccountCreateEdit.vue?vue&type=template&id=8e3a916c&scoped=true"
import script from "./BankAccountCreateEdit.vue?vue&type=script&lang=js"
export * from "./BankAccountCreateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3a916c",
  null
  
)

export default component.exports